import React from 'react';

import { observer } from 'mobx-react';

import ConfirmCheck from 'components/Icons/ConfirmCheck';

import { SimpleModal, StyledModalTitle } from './styles';

// Shared with the audits submission flow; defaults to Event so Events is untouched.
const SubmittedModal: React.FunctionComponent<{ openModal: boolean; entityLabel?: string }> = ({
  openModal,
  entityLabel = 'Event',
}): React.ReactElement => {
  const titleId = React.useId();

  return (
    <SimpleModal
      fullWidth
      maxWidth="md"
      open={openModal}
      aria-labelledby={titleId}
      PaperProps={{
        square: true,
      }}
    >
      <ConfirmCheck data-testid="confirm-check-icon" />
      <StyledModalTitle id={titleId}>{entityLabel} has been successfully submitted!</StyledModalTitle>
    </SimpleModal>
  );
};

export default observer(SubmittedModal);
